//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast } from 'vant'
import { CategoryList, NursingList } from '@/api/index'
export default{
  data () {
    return {
      baseUrl: this.global.baseUrl,
      value: '',
      title: '',
      categoryType: '',
      selectFlag: false,
      funList: [],
      typeList: [],
      nursingList: [],
      activeKey: 0,
    }
  },
  created () {
    this.title = this.$route.query.title
    this.categoryType = this.$route.query.type
    this.getTypeList()
  },
  methods: {
    changeInfo () {
      if (this.value === '') {
        this.selectFlag = false
        return
      }
      NursingList({heading: this.value}).then(resp => {
        if(resp.data){
          this.selectFlag = resp.data.length !== 0
          this.funList = resp.data
        }else{
          this.selectFlag = false
        }
      }).catch(error => {
        this.selectFlag = false
        Toast(error.message)
      })
    },
    funInfo (id) {
      this.$router.push({
        path: '/nursing-info',
        query: {
          id: id,
          title: this.title,
          type: this.categoryType
        }
      })
    },
    getTypeList () {
      CategoryList({type: this.categoryType}).then(resp => {
        this.typeList = resp.data
        const param = {
          categoryId: this.typeList[0].id
        }
        this.getNursingList(param)
      }).catch(error => {
        Toast(error.message)
      })
    },
    nursingInfo (item) {
      this.$router.push({
        path: '/nursing-info',
        query: {
          id: item.id,
          title: this.title,
          type: this.categoryType
        }
      })
    },
    changeTable(item){
      const param = {
        categoryId: item.id
      }
      this.img = item.funImg
      this.getNursingList(param)
    },
    getNursingList (param) {
      NursingList(param).then(resp => {
        this.nursingList = resp.data
      }).catch(error => {
        Toast(error.message)
      })
    },
    reback () {
      this.$router.push({
        path: '/'
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/category.vue